if(!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      image = null;
      stringVariants = null;
      productVariants = null;
      productLinks = null;
      // cartButtons = null;
      colorPicker = null;
      selectedColorDisplay = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.image = this.querySelector('[data-card-image] img');
        this.stringVariants = this.querySelector('[type="application/json"]');
        this.productVariants = null;
        this.productLinks = this.querySelectorAll('.product-link, .bat-btn');
        // this.cartButtons = this.querySelectorAll('[data-cart]');
        this.colorSelectors = this.querySelector('[data-color-selectors]');
        this.selectedColorDisplay = this.querySelector('[data-selected-color]');
        this.deserializeVariants();
        this.initColorSelectors();
        // this.initCartButtons();
      }

      initColorSelectors() {
        if(!this.colorSelectors) return;

        const inputs = this.colorSelectors.querySelectorAll('input');
        this.handleColorChange(inputs);
      }

      handleColorChange(inputs) {
        if(!inputs.length) {
          this.colorPicker.remove();
          return console.error('No options found to initialize the card color picker, removing color picker from DOM.')
        }

        inputs.forEach(input => {
          input.addEventListener('change', (e) => {
            const variantImage = e.target.dataset.productImage;
            const variantId = e.target.dataset.productVariantId;
            
            this.selectedColorDisplay.innerHTML = this.selectedColorDisplay.dataset.productTitle; // + ' - ' + e.target.value;

            this.setAttribute('data-current-variant', variantId);
            
            this.swapImage(variantImage);

            this.handleProductLinks();
          });
        });
      }

      swapImage(image) {
        console.log(image);
        this.image.src = image;
        this.image.alt = "Product image";
      }

      handleProductLinks() {
        if(!this.productLinks?.length) return;

        this.productLinks.forEach(productLink => {
          const href = new URL(productLink.href);
          href.searchParams.set("variant", this.dataset.currentVariant);

          productLink.href = href.toString();
        });
      }

       initCartButtons() {
        if(!this.cartButtons.length) return;

        this.cartButtons.forEach(button => {
          button.addEventListener('click', (e) => this.addToCart(e));
        });
      }

      async addToCart(event, isSample = false) {
        const item = {
          id: this.dataset.currentVariant,
          quantity: 1
        }
        
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [item]
            })
          });

          const data = await response.json();

          if(!response.ok) {
            Toast.notify({
              message: data.message,
              type: "error"
            });
            return console.error('An error ocurred while trying to add product to cart');
          }

          Toast.notify({
            message: `${data.items[0].product_title} was added to cart`,
            type: "success"
          });
        } catch(err) {
          Toast.notify({
            message: "Something went wrong, please try again.",
            type: "error"
          });
          console.error(err);
        }
      }

      deserializeVariants() {
        if(!this.stringVariants) {
          return console.error('No data to deserialize');
        }

        try {
          this.productVariants = JSON.parse(this.stringVariants.textContent);
        } catch(err) {
          this.remove();
          return console.error('An error ocurred deserializing the product variants', err);
        }
      }
    }
  );
}
